import { useState, useEffect } from 'react';

import { Tabs } from '@/components/Tabs';
import { useFormatText } from '@/hooks/useFormatText';
import usePageTitle from '@/hooks/usePageTitle';
import { useSettingsStore } from '@/store/useSettingsStore';

import ClassesTab from './tabs/ClassesTab';
import StudentsTab from './tabs/StudentsTab';
import TeachersTab from './tabs/TeachersTab';

type TReportsTab = 'classes' | 'students' | 'teachers';

const ReportsAnalytics = () => {
  const { formatText } = useFormatText();
  const { setTitle } = usePageTitle();
  const { settings } = useSettingsStore();
  const [activeTab, setActiveTab] = useState<TReportsTab>('classes');

  // Set page title
  useEffect(() => {
    setTitle(formatText('reports-analytics.title'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);

  const tabOptions = [
    {
      label: formatText('reports-analytics.tabs.classes'),
      value: 'classes' as const,
    },
    {
      label: formatText('reports-analytics.tabs.students'),
      value: 'students' as const,
    },
    {
      label: formatText('reports-analytics.tabs.teachers'),
      value: 'teachers' as const,
    },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'classes':
        return <ClassesTab />;
      case 'students':
        return <StudentsTab />;
      case 'teachers':
        return <TeachersTab />;
      default:
        return null;
    }
  };

  return (
    <div
      className="flex flex-col gap-6"
      data-testid="reports-analytics-container"
    >
      {/* Tabs Navigation */}
      <Tabs
        options={tabOptions}
        value={activeTab}
        onChange={setActiveTab}
        dataTestId="reports-analytics-tabs"
      />

      {/* Tab Content */}
      <div className="flex-1" data-testid="reports-analytics-tab-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default ReportsAnalytics;
